import { inject, Injectable } from '@angular/core';
import { PhitoFormDialogConfig } from '../../components/phito-form/phito-form-dialog-config';
import { Documentation, DocumentationPojo } from './documentation-overview/documentation';
import { Validators } from '@angular/forms';
import { PermissionAction } from '../administration/role-and-permissions/role-and-permission';
import { DocumentationChatDialogComponent } from './documentation-chat-dialog/documentation-chat-dialog.component';
import {
    DocumentationChatSimpleDialogComponent,
    DocumentationChatSimpleDialogInput,
} from './documentation-chat-simple-dialog/documentation-chat-simple-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
    providedIn: 'root',
})
export class DocumentationService {

    dialog = inject(MatDialog);

    constructor() { }

    getFormDialogConfigPojo(): PhitoFormDialogConfig<DocumentationPojo> {
        const config = new PhitoFormDialogConfig<Documentation>('Dokumentation', false);
        config.addHeadlineField('Zuweisungen');
        config.addSearchListField(
            'phitoms',
            'Elemente',
            'phitom',
            ['name'],
            PermissionAction.Ansehen('Administration', 'Organisationsbaum'),
        );
        config.addSearchListField(
            'clients',
            'Kunden',
            'clients',
            ['companyName', 'firstName', 'lastName'],
            PermissionAction.Ansehen('Clients', 'Clients'),
        );
        config.addSearchListField(
            'phitomTypes',
            'Kategorien',
            'phitomtype',
            ['name'],
            PermissionAction.Ansehen('Administration', 'Elementtypen'),
        );
        config.addHeadlineField('Zugriff');
        config.addSearchListField(
            'userGroups',
            'Benutzergruppen',
            'usergroupdto',
            ['name'],
            PermissionAction.Ansehen('Administration', 'Benutzergruppen'),
            { idField: 'userGroupHexId' },
        );
        config.addCheckboxField('global', 'Für alle Sichtbar');
        return config;
    }

    getFormDialogConfig(create: boolean): PhitoFormDialogConfig<Documentation> {
        const config = new PhitoFormDialogConfig<Documentation>('Dokumentation', true, {
            persistObject: {
                url: 'documentations',
                autosave: false,
                permissionCreateAndEdit: { menu: 'Documents', group: 'Dokumentation' },
            },
        });
        if (create) {
            config.addTextField('title', 'Titel', { validators: [Validators.required] });
            config.addTextareaField('documentation', 'Inhalt', { microphoneInput: true });
        }
        config.addHeadlineField('Zuweisungen');
        config.addSearchListField(
            'phitoms',
            'Elemente',
            'phitom',
            ['name'],
            PermissionAction.Ansehen('Administration', 'Organisationsbaum'),
        );
        config.addSearchListField(
            'clients',
            'Kunden',
            'clients',
            ['companyName', 'firstName', 'lastName'],
            PermissionAction.Ansehen('Clients', 'Clients'),
        );
        config.addSearchListField(
            'phitomTypes',
            'Kategorien',
            'phitomtype',
            ['name'],
            PermissionAction.Ansehen('Administration', 'Elementtypen'),
        );
        config.addHeadlineField('Zugriff');
        config.addSearchListField(
            'userGroups',
            'Benutzergruppen',
            'usergroupdto',
            ['name'],
            PermissionAction.Ansehen('Administration', 'Benutzergruppen'),
            { idField: 'userGroupHexId' },
        );
        config.addCheckboxField('global', 'Für alle Sichtbar');
        if (create) {
            config.addInfoField('Dokumente können nach dem Speichern hinzugefügt werden!');
        }
        return config;
    }

    openAiChat() {
        this.dialog
            .open(DocumentationChatDialogComponent, {
                width: '90%',
                height: '90%',
                maxWidth: 'none',
                maxHeight: 'none',
                minWidth: '1000px',
            })
            .afterClosed()
            .subscribe({
                next: () => { },
            });
    }

    openAiChatSimple() {
        this.dialog
            .open(DocumentationChatSimpleDialogComponent, {
                width: '400px',
                height: '80vh',
                maxWidth: 'none',
                maxHeight: 'none',
                position: {
                    right: '1vw',
                    top: '2.5vh',
                },
                data: new DocumentationChatSimpleDialogInput(),
            })
            .afterClosed()
            .subscribe({
                next: () => { },
            });
    }
}
